import React, { useEffect } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { FaUser, FaSearch, FaGavel, FaMoneyBillWave, FaTruck, FaCircle } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function BuyerInfoScreen() {
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const plum = COLORS.PLUM;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const InfoCard = ({ icon, title, children }) => (
        <Card className="h-100 border-0 shadow-sm hover-shadow">
            <Card.Body className="p-4">
                <div className="text-center mb-4">
                    <div className="rounded-circle bg-light d-inline-flex p-3">
                        {icon}
                    </div>
                </div>
                <Card.Title className="text-center h5 mb-3" style={{ color: plum }}>{title}</Card.Title>
                <Card.Text className="text-muted">
                    {children}
                </Card.Text>
            </Card.Body>
        </Card>
    );

    return (
        <div className="bg-light min-vh-100 py-5">
            <Container>
                {/* Hero Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: plum }}>
                            Buyer Information
                        </h1>
                        <p className="lead" style={{ color: copper }}>
                            Everything you need to know about buying pigeons through our platform
                        </p>
                    </Col>
                </Row>

                {/* Main Content */}
                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaUser size={24} color={sageGreen} />}
                            title="Getting Started"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Create your account</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Verify your email</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Complete your profile</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Add payment details</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Start browsing auctions</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaSearch size={24} color={sageGreen} />}
                            title="Finding Pigeons"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Browse by category</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Search by breed</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Filter by price range</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Sort by end date</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Save favorites</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaGavel size={24} color={sageGreen} />}
                            title="Bidding Process"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Place your bid</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Automated maximum bid</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Get auction ending soon alerts</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Auto-extension timed system</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Win and lose notification</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>

                {/* Additional Sections */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h2 className="h3 fw-bold mb-4" style={{ color: plum }}>
                            Payment & Collection
                        </h2>
                    </Col>
                </Row>

                <Row className="g-4 mb-5">
                    <Col md={6}>
                        <InfoCard 
                            icon={<FaMoneyBillWave size={24} color={sageGreen} />}
                            title="Payment Options"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Bank EFT payments</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Cash on collection</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> 72-hour payment window</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure transactions</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Payment confirmation</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6}>
                        <InfoCard 
                            icon={<FaTruck size={24} color={sageGreen} />}
                            title="Collection Process"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Arrange collection or delivery</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> 72-hour collection window</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Bring ID document</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Verify pigeon ring number</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Sign collection form</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default BuyerInfoScreen; 